import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ymhkqkhmb: FaireProductEntity = {
  token: "p_7ymhkqkhmb",
  type: "product",
  name: "Regenerative Chicken Bone Broth 16.9oz",
  brandToken: "b_2h8x6r9yrt",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1cdeebf635a96082eec2ad78076e30aee2bf47e8b69d510d7a32022628005a5e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0278115e38e5ff6261a7f4320a8f5d72899421bb07228c984c7c9684a3af9cf.png",
    "https://cdn.faire.com/fastly/b2e42fe6e94b247e7d26507b1367b2af660c2aef1ddaec3525d5a0ab1fd604d8.png",
    "https://cdn.faire.com/fastly/79959391bbb79416ed28da1e22a4f2048198f12ddedcb5a9298e65a0113e806f.png",
    "https://cdn.faire.com/fastly/4bad16202a8dfc2a93b38373acdaf5caf1cedced7554fcbf0b9e4a4bc909ffae.png",
  ],
  priceDollars: 6.23,
  description:
    "Chicken bone broth made with 100% pasture raised chicken bones raised using regenerative agriculture.\t\n\nIngredients:  Chicken Bone Broth (water, chicken bones, organic onions, organic carrots, organic fennel, organic leeks, organic apple cider vinegar, organic thyme, organic shiitake mushrooms, organic tamarind paste, organic bay leaves), Organic Vegetable Broth (organic celery, organic green bell peppers, organic onions, organic carrots, organic garlic, organic scallions, organic tomato puree (organic tomato paste, water), organic parsley, organic thyme, organic rosemary, organic basil, organic spices), Sea Salt. \t\t\t\t\t\t\t\t\n",
  tags: [],
  msrpDollars: 12.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:52.039Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
